import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Close } from '@mui/icons-material';

interface PDFViewerModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  pdfPath: string;
}

const PDFViewerModal: React.FC<PDFViewerModalProps> = ({
  open,
  onClose,
  title,
  pdfPath
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: theme.custom.spacing.borderRadius,
          maxHeight: '90vh',
          height: '90vh'
        }
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: theme.custom.typography.weights.bold,
          color: theme.palette.primary.main,
          borderBottom: `1px solid ${theme.palette.divider}`,
          pb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {title}
        <Button
          onClick={onClose}
          sx={{ minWidth: 'auto', p: 1 }}
          color="inherit"
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Box
          component="iframe"
          src={pdfPath}
          sx={{
            width: '100%',
            height: '100%',
            border: 'none',
            flexGrow: 1
          }}
          title={title}
        />
      </DialogContent>

      <DialogActions
        sx={{
          borderTop: `1px solid ${theme.palette.divider}`,
          pt: 2,
          px: 3,
          pb: 3
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: theme.custom.gradients.button,
            fontWeight: theme.custom.typography.weights.medium,
            '&:hover': {
              background: theme.custom.gradients.buttonHover
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDFViewerModal;
